import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, Button, Card, Row, Col, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { financeSettingsApi, show422Error, ValidationError } from '../../utils/api';

const InvoicePrefixTab = ({ data, onUpdate }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data?.prefix) {
      const p = data.prefix;
      form.setFieldsValue({
        invoice_prefix: p.invoice_prefix,
        invoice_number_separator: p.invoice_number_separator,
        invoice_digit: p.invoice_digit,
        credit_note_prefix: p.credit_note_prefix,
        credit_note_number_separator: p.credit_note_number_separator,
        credit_note_digit: p.credit_note_digit,
        estimate_prefix: p.estimate_prefix,
        estimate_number_separator: p.estimate_number_separator,
        estimate_digit: p.estimate_digit,
        estimate_request_prefix: p.estimate_request_prefix,
        estimate_request_number_separator: p.estimate_request_number_separator,
        estimate_request_digit: p.estimate_request_digit,
        order_prefix: p.order_prefix,
        order_number_separator: p.order_number_separator,
        order_digit: p.order_digit,
        proposal_prefix: p.proposal_prefix,
        proposal_number_separator: p.proposal_number_separator,
        proposal_digit: p.proposal_digit,
      });
    }
  }, [data, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await financeSettingsApi.updatePrefixSettings(values);
      message.success('تنظیمات پیشوند با موفقیت ذخیره شد');
      onUpdate?.();
    } catch (error) {
      console.error('Error updating prefix settings:', error);
      if (error instanceof ValidationError) {
        show422Error(error, form);
      } else {
        message.error('خطا در ذخیره تنظیمات');
      }
    } finally {
      setLoading(false);
    }
  };

  const renderPrefixGroup = (title, prefix, separator, digit) => (
    <Card className="mb-4" size="small" title={<span style={{ fontFamily: 'CustomFont' }}>{title}</span>}>
      <Row gutter={[16, 0]}>
        <Col xs={24} sm={8}>
          <Form.Item
            label={<span style={{ fontFamily: 'CustomFont' }}>پیشوند</span>}
            name={prefix}
            rules={[{ required: true, message: 'الزامی' }]}
          >
            <Input style={{ fontFamily: 'CustomFont' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item
            label={<span style={{ fontFamily: 'CustomFont' }}>جداکننده</span>}
            name={separator}
            rules={[{ required: true, message: 'الزامی' }]}
          >
            <Input style={{ fontFamily: 'CustomFont' }} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item
            label={<span style={{ fontFamily: 'CustomFont' }}>تعداد ارقام</span>}
            name={digit}
            rules={[{ required: true, message: 'الزامی' }]}
          >
            <InputNumber min={1} max={10} style={{ width: '100%', fontFamily: 'CustomFont' }} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );

  return (
    <div style={{ fontFamily: 'CustomFont' }}>
      <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ fontFamily: 'CustomFont' }}>
        {renderPrefixGroup('فاکتور', 'invoice_prefix', 'invoice_number_separator', 'invoice_digit')}
        {renderPrefixGroup('یادداشت اعتباری', 'credit_note_prefix', 'credit_note_number_separator', 'credit_note_digit')}
        {renderPrefixGroup('پیش‌فاکتور', 'estimate_prefix', 'estimate_number_separator', 'estimate_digit')}
        {renderPrefixGroup('درخواست پیش‌فاکتور', 'estimate_request_prefix', 'estimate_request_number_separator', 'estimate_request_digit')}
        {renderPrefixGroup('سفارش', 'order_prefix', 'order_number_separator', 'order_digit')}
        {renderPrefixGroup('پیشنهاد', 'proposal_prefix', 'proposal_number_separator', 'proposal_digit')}

        <div className="flex justify-end">
          <Button
            type="primary"
            htmlType="submit"
            icon={<SaveOutlined />}
            loading={loading}
            className="bg-green-600 hover:bg-green-700 border-0"
            style={{ fontFamily: 'CustomFont' }}
          >
            ذخیره تغییرات
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default InvoicePrefixTab;
